import type { FlowTemplate, PaletteItem } from '../flow-editor/model/types'
import type { FlowGraphNodeV1 } from '../deckplayer/flowchart/flowGraph'
import type { FlowSessionState } from '../deckplayer/flowchart/runtime/sessionState'
import type { FlowRunnerDeps, FlowRunnerProps } from '../deckplayer/flowchart/runtime/useFlowchartRunner'

/** Optional Courses extension. Standalone Flashcards keeps its normal behavior. */
export type PersonalReviewExecution = {
  node: FlowGraphNodeV1
  depth: number
  deps: FlowRunnerDeps
  props: FlowRunnerProps
  state: FlowSessionState
  start: (resumePhaseIdOverride?: string) => void
  nextOf: (fromNodeId: string, preferPorts: string[], strict?: boolean) => string | null
  advanceNext: (nodeId: string, depth: number) => void
}

declare global {
  interface Window {
    PerlingoReview?: {
      palette?: (items: PaletteItem[]) => PaletteItem[]
      templates?: (items: FlowTemplate[]) => FlowTemplate[]
      execute?: (context: PersonalReviewExecution) => boolean
    }
  }
}

export function reviewPalette(items: PaletteItem[]): PaletteItem[] {
  return window.PerlingoReview?.palette?.(items) ?? items
}

export function reviewTemplates(items: FlowTemplate[]): FlowTemplate[] {
  return window.PerlingoReview?.templates?.(items) ?? items
}

/** Returning true holds the flow while a review load/save is pending. */
export function executePersonalReview(context: PersonalReviewExecution): boolean {
  return window.PerlingoReview?.execute?.(context) ?? false
}
